/* eslint-disable no-undef */
import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import "./infoBox.css";

function InfoxBox({ title, cases, active, isRed, total, ...props }) {
  return (
    <Card
      data-testid="infoBoxCard"
      onClick={props.onClick}
      className={`infoBox ${active && "infoBox--selected"} ${
        isRed && "infoBox--red"
      }`}
    >
      <CardContent>
        <Typography className="infoBox__title" color="textSecondary">
          {title}
        </Typography>
        <h2 className={`infoBox__cases ${!isRed && "infoBox__cases--green"}`}>
          {cases}
        </h2>
        <Typography className="infoBox__total" color="textSecondary">
          {total} Total
        </Typography>
      </CardContent>
    </Card>
  );
}

export default InfoxBox;
